export default "__VITE_ASSET__0LCeiDGM__"